import { render, staticRenderFns } from "./ModalCancelamento.vue?vue&type=template&id=1f27d722&lang=pug"
import script from "./ModalCancelamento.vue?vue&type=script&lang=js"
export * from "./ModalCancelamento.vue?vue&type=script&lang=js"
import style0 from "./ModalCancelamento.vue?vue&type=style&index=0&id=1f27d722&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports